import React from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/leaveAdjustmentActions';
import { format } from 'date-fns';
import _ from 'lodash';
import { ChatBubbleOvalLeftEllipsisIcon
, PencilSquareIcon } from "@heroicons/react/20/solid";

const LeaveAdjustmentRow = ({
    adjustment,
    setOpenModal,
    userPermissions,
    isSaving,
    leaveType,
    showComments,
    employees
}) => {

    const employee = employees && employees.find(i => i.id == adjustment.agreementId)

    const date = format(new Date(adjustment.date), "do MMMM yyyy")
    return (
        <tr>
            <td>
                {date}
            </td>
            <td>
                {employee && employee.employeeName} {employee && employee.employeeSurname}
            </td>
            <td>
                {adjustment.adjustmentType}
            </td>
            <td>
                {leaveType.find(i => i.id == adjustment.leaveType) && leaveType.find(i => i.id == adjustment.leaveType).name}
            </td>
            <td>
                {parseFloat(adjustment.hours).toFixed(2)}
            </td>
            <td className="text-center">
                {adjustment.comments && adjustment.comments.length > 0 &&
                    <a style={{ marginRight: "5px" }} className="btn btn-xs btn-default" title="Show Comments" onClick={() => { showComments(adjustment) }}>
                        <ChatBubbleOvalLeftEllipsisIcon
 className="h-5 w-5 text-dark-gray" style={{ marginTop: "3px" }}/>
                    </a>
                }

                {userPermissions !='Read' &&
                    <a className="btn btn-xs btn-default" title="Edit Leave Adjustment Request" onClick={() => { setOpenModal(true, adjustment) }}>
                        <PencilSquareIcon className="h-5 w-5 text-dark-gray" style={{ marginTop: "3px" }} />
                    </a>
                }
            </td>
        </tr>
    )
}


const mapStateToProps = (state, ownProps) => {

    const userPermissions = state?.permissions?.my?.permissions?.leave

    return {
        userPermissions,
        leaveType: state.leave.leaveTypes,
        employees: state.employees.employeeListWithSalary
    }
}

const mapDispatchToProps = dispatch => ({
    setOpenModal: (status, leaveAdj) => dispatch(ACTIONS.setOpenLeaveAdjustmentModal(status, leaveAdj)),
    saveLeave: (leaveAdj) => dispatch(ACTIONS.saveLeaveAdjustment(leaveAdj)),
    showCancelLeave: (leaveAdj, status) => dispatch(ACTIONS.showCancelLeaveAdjustment(leaveAdj, status)),
    showComments: (leaveAdj) => dispatch(ACTIONS.showLeaveAdjustmentComments(leaveAdj)),
    showAttachments: (leaveAdj) => dispatch(ACTIONS.showLeaveAdjustmentAttachments(leaveAdj)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveAdjustmentRow)